import Vue from 'vue'
import Router from 'vue-router'

import Base from '@/components/Base'
import Login from '@/components/Auth/Login'
import Register from '@/components/Auth/Register'
import Reset from '@/components/Auth/Reset'
import PasswordEdit from '@/components/Profile/PasswordEdit'

import ProfileBase from '@/components/Profile/ProfileBase'

import Dashboard from '@/components/Admin/Dashboard'
import AdminBodies from '@/components/Admin/AdminBodies'
import AdminBody from '@/components/Admin/AdminBody'
import AdminApplicants from '@/components/Admin/AdminApplicants'
import AdminApplicant from '@/components/Admin/AdminApplicant'
import AdminContacts from '@/components/Admin/Contacts/Contacts'
import AdminTasks from '@/components/Admin/AllTasks'
import AdminOverview from '@/components/Admin/AdminOverview'
import AdminActivities from '@/components/Admin/AllActivities'
import AdminDeadlines from '@/components/Admin/AdminDeadlines'
import AdminTeam from '@/components/Admin/AdminTeam'

// Static pages
import Terms from '@/components/Static/Terms'

import BaseDashboard from '@/components/BaseDashboard'

import { store } from '@/store'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: '/',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) return savedPosition
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'base',
      component: Base,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin',
      component: Dashboard,
      children: [
        {
          path: '',
          name: 'admin',
          component: AdminOverview,
          meta: { requiresAuth: true, requiresAdmin: true }
        },
        {
          path: 'bodies',
          name: 'admin-bodies',
          component: AdminBodies,
          meta: { requiresAuth: true, requiresAdmin: true }
        },
        {
          path: 'applicants',
          name: 'admin-applicants',
          component: AdminApplicants,
          meta: { requiresAuth: true, requiresAdminOrManager: true }
        },
        {
          path: 'contacts',
          name: 'admin-contacts',
          component: AdminContacts,
          meta: { requiresAuth: true, requiresAdmin: true }
        },
        {
          path: 'applicants/:id',
          name: 'admin-applicant',
          component: AdminApplicant,
          meta: { requiresAuth: true, requiresAdminOrManager: true }
        },
        {
          path: 'bodies/:id',
          name: 'admin-body',
          component: AdminBody,
          props: true,
          meta: { requiresAuth: true, requiresAdmin: true }
        },
        {
          path: 'tasks',
          name: 'admin-tasks',
          component: AdminTasks,
          meta: { requiresAuth: true, requiresAdminOrManager: true }
        },
        {
          path: 'activities',
          name: 'admin-activities',
          component: AdminActivities,
          meta: { requiresAuth: true, requiresAdmin: true }
        },
        {
          path: 'deadlines',
          name: 'admin-deadlines',
          component: AdminDeadlines,
          meta: { requiresAuth: true, requiresAdmin: true }
        },
        {
          path: 'team',
          name: 'admin-team',
          component: AdminTeam,
          meta: { requiresAuth: true, requiresAdmin: true }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/reset',
      name: 'reset',
      component: Reset
    },
    {
      path: '/profile',
      component: BaseDashboard,
      children: [
        {
          path: '',
          name: 'profile',
          component: ProfileBase,
          meta: { requiresAuth: true }
        },
        {
          path: 'password',
          name: 'password-edit',
          component: PasswordEdit,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms
    },
    {
      path: '*',
      component: Base
    }
  ]
})

router.beforeEach((to, from, next) => {
  let currentUser = store.state.auth.user
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  let requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  let requiresAdminOrManager = to.matched.some(record => record.meta.requiresAdminOrManager)

  if (requiresAuth && !currentUser) {
    next('login')
  } else if (requiresAdmin && currentUser && !currentUser.isAdmin) {
    next({ name: 'base' })
  } else if (requiresAdminOrManager && currentUser && !currentUser.isAdmin && !currentUser.isManager) {
    next({ name: 'base' })
  } else {
    next()
  }
})

export default router
